/* Raindoor Design System — Landing Denim.
   Un grupo [data-dn-group] tiene botones [data-dn-pick="i"] y elementos [data-dn-i="i"]:
   al tocar un botón, todo lo del mismo índice queda con .is-on (tabs, filas, paneles, puntos).
   data-dn-toggle permite cerrar el activo (preguntas). data-dn-band mueve la banda del tiro. */
(function () {
  if (window.rdDenimReady) return;
  window.rdDenimReady = true;

  function own(group, el) {
    return el.closest('[data-dn-group]') === group;
  }

  function pick(group, index) {
    group.querySelectorAll('[data-dn-i]').forEach(function (el) {
      if (!own(group, el)) return;
      var on = index !== null && el.getAttribute('data-dn-i') === index;
      el.classList.toggle('is-on', on);
      if (el.getAttribute('role') === 'tab') el.setAttribute('aria-selected', on ? 'true' : 'false');
      if (el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on && el.hasAttribute('data-dn-band')) group.style.setProperty('--dn-band', el.getAttribute('data-dn-band') + '%');
    });
  }

  function init(root) {
    root.querySelectorAll('[data-dn-group]').forEach(function (group) {
      if (group.hasAttribute('data-dn-ready')) return;
      group.setAttribute('data-dn-ready', '');
      group.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-dn-pick]');
        if (!trigger || !own(group, trigger)) return;
        var index = trigger.getAttribute('data-dn-pick');
        var close = group.hasAttribute('data-dn-toggle') && trigger.classList.contains('is-on');
        pick(group, close ? null : index);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Editor de temas: al recargar una sección o elegir un bloque, se muestra ese bloque */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var index = el.getAttribute && el.getAttribute('data-dn-i');
    var group = el.closest && el.closest('[data-dn-group]');
    if (index !== null && group) pick(group, index);
  });
})();
